import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "../utils/cn"

const badgeVariants = cva(
    "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
    {
        variants: {
            variant: {
                default: "border-transparent bg-mint/90 text-ink hover:bg-mint-hover/90",
                secondary: "border-transparent bg-gold/90 text-ink hover:bg-gold-hover/90",
                destructive: "border-transparent bg-pink/90 text-paper hover:bg-pink-hover/90",
                outline: "text-foreground border-ink",
                success: "border-transparent bg-status-completed text-paper hover:bg-[#27ae60]",
                warning: "border-transparent bg-status-generating text-ink hover:bg-[#f39c12]",
            },
        },
        defaultVariants: {
            variant: "default",
        },
    }
)

export interface BadgeProps
    extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> { }

function Badge({ className, variant, ...props }: BadgeProps) {
    return (
        <div className={cn(badgeVariants({ variant }), className)} {...props} />
    )
}

export { Badge, badgeVariants }










